<script>
export default {
  name: 'ValidateMixin',
  computed: {
    // 存在重复的英文名称
    hasRepeatVariable () {
      if (this.moduleData.current == null) {
        return false
      }
      return !this.validateFieldRepeat(this.moduleData.current, 'variable')
    },
    // 存在重复的中文名称
    hasRepeatLabel () {
      if (this.moduleData.current == null) {
        return false
      }
      return !this.validateFieldRepeat(this.moduleData.current, 'label')
    },
    // 存在英文名称未填写
    hasEmptyVariable () {
      if (this.moduleData.current == null) {
        return false
      }
      return !this.validateFieldRequired(this.moduleData.current, 'variable')
    },
    // 存在中文名称未填写
    hasEmptyLabel () {
      if (this.moduleData.current == null) {
        return false
      }
      return !this.validateFieldRequired(this.moduleData.current, 'label')
    },
    // 存在无效的字段英文名称
    hasInvalidVariable () {
      if (this.moduleData.current == null) {
        return false
      }
      return !this.validateVariable(this.moduleData.current)
    },
    // 存在图片类型字段
    hasImageField () {
      if (this.moduleData.current == null) {
        return false
      }
      return this.validateDataTypeMissing(this.moduleData.current, 'IMAGE')
    },
    // 存在数字类型字段
    hasNumberField () {
      if (this.moduleData.current == null) {
        return false
      }
      return this.validateDataTypeMissing(this.moduleData.current, 'NUMBER')
    },
    // 存在字段没有数据
    hasFieldWithoutRows () {
      if (this.moduleData.current == null) {
        return false
      }
      return !this.validateModuleFieldRowMissing(this.moduleData.current)
    },
    // 模块字段没有数据
    hasModuleField () {
      if (this.moduleData.current == null) {
        return false
      }
      return this.validateModuleField(this.moduleData.current)
    },
    // 存在字段数据条数未匹配
    hasFieldRowsNotMatched () {
      if (this.moduleData.current == null) {
        return false
      }
      return !this.validateModuleFieldRowNotMatch(this.moduleData.current)
    }
  },
  methods: {
    // 确认录入验证
    validateConfirmInput () {
      if (this.form.systemName.trim() === '') {
        return Promise.reject('请输入系统名称')
      }
      if (this.form.industryId === null) {
        return Promise.reject('请选择行业')
      }
      if (this.moduleData.list.length === 0) {
        return Promise.reject('至少需要一个模块')
      }
      for (const module of this.moduleData.list) {
        if (!this.validateFieldRequired(module, 'variable')) {
          return Promise.reject('存在字段英文名称未填写，请检查')
        }
        if (!this.validateFieldRequired(module, 'label')) {
          return Promise.reject('存在字段中文名称未填写，请检查')
        }
        if (!this.validateFieldRepeat(module, 'variable')) {
          return Promise.reject('存在字段英文名称重复，请检查')
        }
        if (!this.validateFieldRepeat(module, 'label')) {
          return Promise.reject('存在字段中文名称重复，请检查')
        }
        if (!this.validateVariable(module, 'variable')) {
          return Promise.reject('存在字段英文名称格式不正确，请检查')
        }
        if (!this.validateModuleFieldRowMissing(module)) {
          return Promise.reject('存在字段没有模拟数据，请检查')
        }
        if (!this.validateModuleField(module)) {
          return Promise.reject('存在模块没有字段信息，请检查')
        }
      }
      return new Promise((resolve) => {
        for (const module of this.moduleData.list) {
          if (!this.validateModuleFieldRowNotMatch(module)) {
            return resolve(`${module.moduleName}模块的模拟数据可能不正确`)
          }
          if (!this.validateDataTypeMissing(module, 'IMAGE')) {
            return resolve('存在模块缺少图片字段')
          }
          if (!this.validateDataTypeMissing(module, 'NUMBER')) {
            return resolve('存在模块缺少数字字段')
          }
        }
        resolve()
      })
    },
    // 验证英文名称是否正确
    validateVariable (module) {
      for (const field of module.fields) {
        if (field.variable.length < 3) {
          return false
        }
        if (!/^[a-z]+[a-z0-9_]+$/.test(field.variable)) {
          return false
        }
        if (field.variable.startsWith('_') || field.variable.endsWith('_')) {
          return false
        }
      }
      return true
    },
    // 验证字段是否必填
    validateFieldRequired (module, fieldName) {
      return module.fields.filter(item => item[fieldName] == null || item[fieldName].trim() === '').length === 0
    },
    // 验证字段是否重复
    validateFieldRepeat (module, fieldName) {
      const values = module.fields.map(item => item[fieldName])
      const valueSet = new Set(values)
      return values.length === valueSet.size
    },
    // 验证数据类型是否确实
    validateDataTypeMissing (module, targetValue) {
      return module.fields.filter(item => item.dataType === targetValue).length > 0
    },
    // 验证模块字段数据是否完整
    validateModuleFieldRowMissing (module) {
      if (module.fields.length === 0) {
        return true
      }
      return module.fields.filter(field => field.fieldType.length === 0 && field.rows.length === 0).length === 0
    },
    // 验证模块是否存在字段信息
    validateModuleField (module) {
      return module.fields.length > 0
    },
    // 验证模块字段数据是否完整
    validateModuleFieldRowNotMatch (module) {
      if (module.fields.length === 0) {
        return true
      }
      return module.fields.filter(field => field.fieldType.length === 0 && !field.label.startsWith('是否') && field.rows.length !== 5).length === 0
    }
  }
}
</script>
